import { memo, useMemo } from "react";

import type { FormSettings } from "../../form-print.utils";
import PdfDocumentHtmlSimple from "./pdf-document-html-simple.component";
import PdfDocumentHtmlWithTableAdjustments from "./pdf-document-html-with-table-adjustments.component";

type PdfDocumentHtmlProps = {
  bodyHtml?: string | null;
  pdfNativeTablesEnabled?: boolean;
  printableTableLayoutFixesEnabled?: boolean;
  formSettings?: FormSettings | null;
};

function PdfDocumentHtml({
  bodyHtml,
  pdfNativeTablesEnabled,
  printableTableLayoutFixesEnabled,
  formSettings
}: PdfDocumentHtmlProps) {
  // Optimize table detection by caching the result
  const shouldUseTableAdjustments = useMemo(() => {
    return pdfNativeTablesEnabled && bodyHtml && bodyHtml.includes("<table");
  }, [pdfNativeTablesEnabled, bodyHtml]);

  if (shouldUseTableAdjustments) {
    return (
      <PdfDocumentHtmlWithTableAdjustments
        bodyHtml={bodyHtml}
        printableTableLayoutFixesEnabled={printableTableLayoutFixesEnabled}
        formSettings={formSettings}
      />
    );
  } else {
    return (
      <PdfDocumentHtmlSimple
        bodyHtml={bodyHtml}
        printableTableLayoutFixesEnabled={printableTableLayoutFixesEnabled}
        formSettings={formSettings}
      />
    );
  }
}

// Memoize component to prevent unnecessary re-renders
export default memo(PdfDocumentHtml);
